import React from "react";

function Waiting() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.86316 4.16113V9.07565L12.0914 11.3095"
        stroke="#F44336"
        strokeWidth="1.21969"
        strokeLinecap="round"
      />
      <path
        d="M4.69778 13.9903C6.03444 15.2847 7.85411 16.081 9.85931 16.081C13.9628 16.081 17.2894 12.7461 17.2894 8.63228C17.2894 4.51848 13.9628 1.18359 9.85931 1.18359C6.53334 1.18359 3.71778 3.37442 2.7702 6.3951"
        stroke="#F44336"
        strokeWidth="1.21969"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.84245 5.70484L2.55411 7.23325L0.950012 5.05469"
        stroke="#F44336"
        strokeWidth="1.21969"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Waiting;
